import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _bindInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/bind';
import _setTimeout from '@babel/runtime-corejs3/core-js-stable/set-timeout';
import _mapInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/map';
import classNames from 'classnames/bind';
import React, { useState, useRef, useEffect } from 'react';
import style from './RollingAnimation.module.scss.js';

var cx = _bindInstanceProperty(classNames).call(classNames, style);
var DEFAULT_DELAY = 3000;
/**
 * 컨텐츠를 롤링하는 유틸성 컴포넌트
 * - Position, Fade 두 가지 타입을 제공한다
 *
 * ```jsx
 * <RollingAnimation animationType={ANIMATION_TYPE.POSITION} items={[
 *     <p key="rolling-text1">
 *            <strong>55개 금융사</strong>에서 가장 좋은 상품 찾기
 *     </p>,
 *     <p key="rolling-text2">
 *            몇번을 조회해도<strong>신용점수는 그대로</strong>
 *     </p>,
 * ]}/>
 * ```
 */
function RollingAnimation(_ref) {
  var animationType = _ref.animationType,
    items = _ref.items,
    _ref$delay = _ref.delay,
    delay = _ref$delay === void 0 ? DEFAULT_DELAY : _ref$delay;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    index = _useState2[0],
    setIndex = _useState2[1];
  var timer = useRef();
  useEffect(function () {
    var nextIndex = (index + 1) % items.length;
    timer.current = _setTimeout(function () {
      setIndex(nextIndex);
    }, delay);
    return function () {
      timer.current && clearTimeout(timer.current);
    };
  }, [delay, index, items.length]);
  return /*#__PURE__*/React.createElement("div", {
    className: cx('article', animationType)
  }, _mapInstanceProperty(items).call(items, function (item, itemIndex) {
    return /*#__PURE__*/React.createElement("div", {
      className: cx('item', "".concat(itemIndex === index ? 'show' : 'hide')),
      key: itemIndex
    }, item);
  }));
}

export { DEFAULT_DELAY, RollingAnimation as default };
